const locale = {
	TITLE: 'Load Search - Spanish'
};

export default locale;
